import { captureException } from "@stadium/services/error-reporting";

const WEGLOT_COMPONENT = "weglot";

/** Report Weglot failures to the configured error monitoring provider (Sentry / Datadog). */
export const logWeglotError = (message, { error, extra } = {}) => {
  const reportedError = error instanceof Error ? error : new Error(message);

  // Always attach the caller-provided message so it appears in monitoring even
  // when an Error object was supplied (the original error.message is preserved
  // in the `extra` payload below).
  if (message) {
    reportedError.message = message;
  }

  captureException(reportedError, {
    level: "error",
    tags: { component: WEGLOT_COMPONENT },
    extra: { message, ...extra },
  });
};
